<template>
  <div
    id="init-home-container"
    class="mt-3 d-flex flex-column white--text"
    style="width: 100%"
  >
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-spacer></v-spacer>
    <v-main>
      <v-container
        class="cmpbk black--text"
        id="home-container"
        style="max-width: 768px"
      >
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <v-card elevation="2" class="d-flex justify-center">
              <v-card-title class="py-0">Admin</v-card-title>
            </v-card>
            >
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <v-expansion-panels id="all-panels" v-model="panels">
              <v-expansion-panel>
                <v-expansion-panel-header>Search</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <adm_search @search="search"></adm_search>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="show_srch_res_now">
                <v-expansion-panel-header
                  >Search Results</v-expansion-panel-header
                >
                <v-expansion-panel-content color="cmpbkinside">
                  <adm_srch_results></adm_srch_results>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>Recent</v-expansion-panel-header>
                <v-expansion-panel-content color="cmpbkinside">
                  <adm_recent></adm_recent>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
//adm_search
const adm_search = () => import("./adm_search.vue");
//adm_recent
const adm_recent = () => import("./adm_recent.vue");
//adm_srch_results
const adm_srch_results = () => import("./adm_srch_results.vue");
//adm_srch_results
export default {
  name: "admin",
  mixins: [bus_common],
  components: { adm_search, adm_recent, adm_srch_results },
  data() {
    return {
      panels: 0,
      show_srch_res_now: false,
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    search() {
      this.show_srch_res_now = true;
    },
    init() {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
